const EMAIL_PROVIDERS = {
  Outlook: "3",
  Gmail: "2",
  Zoho: "1",
};

export default EMAIL_PROVIDERS;
